import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import dashboard from '../../resource/middleware_mobile/dashboard.png';


const DashboardMobile = () => {
    return (
        <ProductItemView
            title="Tablero de Control Web"
            items={["Administración simple desde un sitio web", "Dashboard de conexiones en tiempo real", "Monitor de comunicaciones en tiempo real"]}
            image={dashboard}
            centered
            withGap />
    );
};

export default DashboardMobile;